import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import { BaseText, Meta, theme } from 'aimo-ui';
import { QuickActionButton } from 'components/common/QuickActionButton';
import React from 'react';
import { StyleSheet } from 'react-native';
import { Maybe, ParkingSpace } from 'types/generatedSchemaTypes';
import { RootStackParamList } from 'types/navigation';
import { getParkingSpacesText } from 'utils/permitUtils.ts';

const PermitParkingSpace: React.FC<{
  parkingSpaces: Maybe<ParkingSpace>[];
  spotMap: Maybe<string> | undefined;
  meta?: boolean;
  textColor?: string;
  freetextParkingSpaceNo?: Maybe<string>;
}> = ({
  parkingSpaces,
  spotMap,
  textColor,
  meta,
  freetextParkingSpaceNo = '',
}) => {
  const { navigate } = useNavigation<StackNavigationProp<RootStackParamList>>();

  const onPress = () => {
    if (spotMap) {
      return navigate('parkingSpaceMapViewer', {
        spotMap: spotMap,
        showOnlyMap: true,
      });
    }
  };
  if (parkingSpaces.length === 0 && !freetextParkingSpaceNo) {
    return <></>;
  }
  const SubtitleComponent = meta ? Meta : BaseText;
  return (
    <QuickActionButton
      testID="quick-button-parking-space"
      onPress={onPress}
      disabled={!spotMap}
      iconName={
        spotMap
          ? 'Pin-Outlined'
          : parkingSpaces?.length > 3
            ? 'Chevron_Right'
            : ''
      }
      coloring={theme.colors.gray300}
      subtitle={
        <SubtitleComponent style={styles.subtitle} color={textColor}>
          {getParkingSpacesText(parkingSpaces, freetextParkingSpaceNo)}
        </SubtitleComponent>
      }
      flexRow
    />
  );
};

export default PermitParkingSpace;

const styles = StyleSheet.create({
  subtitle: {
    textAlign: 'right',
  },
});
